import React, { createContext, useContext, useState } from 'react';
import { NavigationContextType, View } from '../types'; 

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentView, setView] = useState<View>('home');
  const [selectedProductId, setSelectedProductId] = useState<string | null>(null);

  return (
    <NavigationContext.Provider value={{ 
      currentView, 
      setView,
      selectedProductId,
      setSelectedProductId
    }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};
